<template>
    <property-base :label="label.text" :forInput="label.for">
        <template v-for="(mid, idx) in newValue">
            <div class="row form-group" :key="idx">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12">
                            {{resource('JourneyBuilder_FilterSettings_ContentTool')}}
                        </div>
                        
                        <div class="col-4">
                            <input-group icon="fa fa-percent" class="h-100">
                                <input v-model.number="mid.percentage"

                                       class="form-control"
                                       type="number"
                                       :min="rules.percentage.minValue"
                                       :max="rules.percentage.maxValue"
                                />
                            </input-group>
                        </div>
                        <div class="col-8">
                            <input-group icon="far fa-newspaper" class="h-100">
                                <v-select class="form-control"

                                          v-model="newValue[idx].contentId"

                                          :options="options"
                                          :disabled="!canWrite"

                                          searchable
                                          filterable
                                          taggable

                                          close-on-select
                                >
                                    <div slot="no-options" />
                                </v-select>
                            </input-group>
                        </div>
                    </div>
                    
                    <min-value-error-message
                            v-if="!$v.newValue.$each.$iter[idx].percentage.minValue"
                            field-name="Percentage"
                            :min-value="rules.percentage.minValue"
                    />
                    <max-value-error-message
                            v-if="!$v.newValue.$each.$iter[idx].percentage.maxValue"
                            field-name="Percentage"
                            :max-value="rules.percentage.maxValue"
                    />
                </div>
                <div class="col-2 d-flex flex-column">
                    <button
                            v-if="newValue.length !== 1"
                            class="btn btn-outline-danger mt-auto"
                            :class="{ disabled: !canWrite }"
                            @click="removeMidAt(idx)"
                    >
                        <i class="fa fa-minus"/> 
<!--                        {{resource('Button_Remove')}}-->
                    </button>
    
                    <button
                            v-if="idx + 1 === newValue.length"
    
                            :class="[newValue.length === 1 ? 'mt-auto' : 'mt-1']"
                            class="btn btn-outline-secondary"
                            @click="addMid"
                    >
                        <i class="fa fa-plus"/>
<!--                        {{resource('Button_Add')}}-->
                    </button>
                </div>
            </div>
        </template>

        <error-message
                v-if="!$v.newValue.hasFullPercentage"
                :message="resource('JourneyBuilder_ContentSettings_PercentageSum_ErrorMessage')"
        />
    </property-base>
</template>

<script>
import { minValue, maxValue } from 'vuelidate/lib/validators'
    
import resources from '../../../../../../Util/Mixins/resources';
import permissionsMixin from '../../../../Mixins/journey-permissions';
import { validationMixin  } from 'vuelidate'

import InputGroup from '../../../../../../Components/Inputs/InputGroup.vue';
import JourneyConnectionPropertyBase from './../JourneyConnectionPropertyBase.vue';
import ErrorMessage from "../../../../../../Components/Errors/ErrorMessage.vue";
import RequiredErrorMessage from "../../../../../../Components/Errors/RequiredErrorMessage.vue";
import MinValueErrorMessage from "../../../../../../Components/Errors/MinValueErrorMessage.vue";
import MaxValueErrorMessage from "../../../../../../Components/Errors/MaxValueErrorMessage.vue";
import VSelect from 'vue-select';

const rules = Object.freeze({
    percentage: {
        minValue: 1,
        maxValue: 100
    }
});

export default {
    name: 'journey-connection-content',
    components: {
        'PropertyBase': JourneyConnectionPropertyBase,
        InputGroup,
        ErrorMessage,
        RequiredErrorMessage,
        MinValueErrorMessage,
        MaxValueErrorMessage,
        VSelect
    },
    mixins: [resources, permissionsMixin, validationMixin],
    created() {
        const vm = this;
        
        vm.newValue = vm.value.map(v => ({
            contentId: v.contentId,
            percentage: v.percentage
        }));
        
        if(vm.newValue.length === 0){
            const initialMid = this.addMid();
            
            //Take 100 by default
            initialMid.percentage = 100;
        }
    },
    validations: {
        newValue: {
            $each: {
                percentage: {
                    minValue: minValue(rules.percentage.minValue),
                    maxValue: maxValue(rules.percentage.maxValue)
                }
            },
            hasFullPercentage(value){
                //An empty collection should not be validated
                if(!value || !value.length){
                    return true;
                }
                
                //Full percentage should be exactly 100%
                return value.reduce((sum, {percentage}) => {
                    return sum + percentage;
                }, 0) === 100;
            }
        }
    },
    methods: {
        addMid(){
            const mid = {
                contentId: '',
                percentage: rules.percentage.minValue
            };
            
            this.newValue.push(mid);
            
            return mid;
        },
        removeMidAt(index){
            this.newValue.splice(index, 1);
        }
    },
    computed: {
        label() {
            return {
                text:  this.resource('JourneyBuilder_FilterSettings_Content_DisplayName'),
                for: this.elementName
            }
        }
    },
    watch: {
        newValue(value) {
            if(value != this.value) {
                this.$emit('input', value);
            }
        }
    },
    data() {
        return {
            rules,
            newValue: [],
            elementName: 'Content'
        }
    },
    props: {
        value: {
            type: Array,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.btn .fa:not(.fa-play) {
    margin-right: 0;
}
</style>



